import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import styled from 'styled-components';

import Page from '@glowforge/gf-styled/src/components/contentful-views/page';
import ContentPageStyled from '@glowforge/gf-styled/src/components/content-page.styled';
import { getStandalonePageBySlug } from '../../api/contentful';
import { pagePropType } from '../../prop-types/contentful';
import { authorizePageView } from '../../util/authorize';
import Canonical from '../../util/canonical'

// TODO: Replace with dynamic importer
import '@glowforge/gf-styled/src/initializers/contentful-page';

const MarketingPage = ({ page, className, slug }) => (
    <>
      <Canonical path={`m/${slug}`}/>
      {page?.fields?.noindex || page?.fields?.visibility !== 'public' ? (
        <Head>
          <meta name='robots' content='noindex'/>
        </Head>
      ):null}
      <ContentPageStyled>
        <Page
          className={`GlowforgeMarketingPage contentPage ${className}`}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...page.fields}
        />
      </ContentPageStyled>
    </>
  );

export const getServerSideProps = async (ctx) => {
  const { slug } = ctx.query;
  const page = await getStandalonePageBySlug(slug);
  await authorizePageView(ctx, page);
  return {
    props: { page, slug }
  };
};

MarketingPage.propTypes = {
  page: pagePropType.isRequired,
  className: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
};

// Contentful Sitemap Configuration for this slug route
export const sitemapConfig = {
  path: '/m',
  contentType: 'page',
  extraQuery: {
    'fields.pageType': 'standalone',
    'fields.visibility': 'public'
  }
}

export default styled(MarketingPage)`
  .h1 {
    text-align: center;
    padding: 2rem 0;
  }
`;
